/**
 * 헤더에 표시할 문구를 설정한다.
 * @param {*} state
 * @param {string} subtitle - 헤더에 표시할 문구
 */
const SET_USER_DATA = (state, { loginID, nexonName, couponCount, balance }) => {
  state.loginID = loginID
  state.nexonName = nexonName
  state.couponCount = couponCount
  if (balance) {
    state.balance.total = balance.total
    state.balance.currencyName = balance.currencyName
    state.balance.currencyUnit = balance.currencyUnit
  }
}

const SET_USER_BALANCE = (state, data) => {
  state.balance.total = data.total
  state.balance.currencyName = data.currencyName
  state.balance.currencyUnit = data.currencyUnit
}

const SET_PURCHASE = (
  { purchase },
  { purchaseList, totalCount, totalPageCount, pageNo, pageSize }
) => {
  purchase.purchaseList = purchaseList
  purchase.totalCount = totalCount
  purchase.totalPageCount = totalPageCount
  purchase.pageNo = pageNo
  purchase.pageSize = pageSize
}

const SET_WITHDRAW = (
  { withdraw },
  { purchaseWithdrawList, totalCount, totalPageCount, pageNo, pageSize }
) => {
  withdraw.purchaseWithdrawList = purchaseWithdrawList
  withdraw.totalCount = totalCount
  withdraw.totalPageCount = totalPageCount
  withdraw.pageNo = pageNo
  withdraw.pageSize = pageSize
}

/* const SET_COUPON_LIST = (state, couponList) => {
  state.couponList = couponList
} */

const SET_COUPONUSABLE = (
  { couponUsable },
  { lastPurchaseProductCouponId, couponUsableList, last, reset }
) => {
  if (reset) {
    couponUsable.lastPurchaseProductCouponId = lastPurchaseProductCouponId
    couponUsable.couponUsableList = couponUsableList
    couponUsable.last = false
    return
  }

  couponUsable.lastPurchaseProductCouponId = lastPurchaseProductCouponId
  if (couponUsableList.length) {
    // 정상 응답
    couponUsable.couponUsableList.push(...couponUsableList)
    if (couponUsableList.length < couponUsable.pageSize) {
      couponUsable.last = true
    }
  } else {
    if (
      couponUsable.lastPurchaseProductCouponId === 0 &&
      couponUsable.couponUsableList.length === 0
    ) {
      couponUsable.couponUsableList = couponUsableList
    }
    couponUsable.last = typeof last != 'undefined' ? last : true
  }
}

const SET_COUPONUNUSABLE = (
  { couponUnusable },
  { lastPurchaseProductCouponId, couponUnusableList, last, reset }
) => {
  if (reset) {
    couponUnusable.lastPurchaseProductCouponId = lastPurchaseProductCouponId
    couponUnusable.couponUnusableList = couponUnusableList
    couponUnusable.last = false
    return
  }

  couponUnusable.lastPurchaseProductCouponId = lastPurchaseProductCouponId
  if (couponUnusableList.length) {
    // 정상 응답
    couponUnusable.couponUnusableList.push(...couponUnusableList)
    if (couponUnusableList.length < couponUnusable.pageSize) {
      couponUnusable.last = true
    }
  } else {
    if (
      couponUnusable.lastPurchaseProductCouponId === 0 &&
      couponUnusable.couponUnusableList.length === 0
    ) {
      couponUnusable.couponUnusableList = couponUnusableList
    }
    couponUnusable.last = typeof last != 'undefined' ? last : true
  }
}

const SET_REWARDINFO = (state, value) => (state.rewardInfo = value)

const SET_ALLTEM_PURCHASE_PRODUCT_LIST = (state, value) =>
  (state.alltemPurchaseProductList = value.alltemPurchaseProductList)

const SET_ALLTEM_PURCHASE_START_DATE = (state, alltemPurchaseStartDate) =>
  (state.alltemPurchaseStartDate = alltemPurchaseStartDate)

const SET_ALLTEM_PURCHASE_END_DATE = (state, alltemPurchaseEndDate) =>
  (state.alltemPurchaseEndDate = alltemPurchaseEndDate)

export default {
  SET_USER_DATA,
  SET_USER_BALANCE,
  SET_PURCHASE,
  SET_WITHDRAW,
  SET_REWARDINFO,
  SET_COUPONUSABLE,
  SET_COUPONUNUSABLE,
  SET_ALLTEM_PURCHASE_PRODUCT_LIST,
  SET_ALLTEM_PURCHASE_START_DATE,
  SET_ALLTEM_PURCHASE_END_DATE
}
